import { Eye } from "lucide-react";
import { AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from "recharts";
import { SectionHeading, scoreTone } from "./ResultsPrimitives";

const TREND = { sube: "↗", baja: "↘", estable: "→" };

export default function RetentionSection({ blocks }) {
  const data = blocks.map((b) => ({ name: b.block_name, ret: Number(b.estimated_retention) || 0, ts: b.timestamp }));
  return (
    <section data-testid="retention-section">
      <SectionHeading eyebrow="Nivel 3" title="Retención por Bloques" icon={Eye} accent="cyan" />
      <div className="mt-4 vt-card bg-brand-card p-4 md:p-6">
        <div className="h-56 md:h-64 w-full">
          <ResponsiveContainer width="100%" height="100%">
            <AreaChart data={data} margin={{ top: 10, right: 12, left: -18, bottom: 0 }}>
              <defs>
                <linearGradient id="retLine" x1="0" y1="0" x2="1" y2="0">
                  <stop offset="0%" stopColor="#8B5CF6" />
                  <stop offset="100%" stopColor="#06B6D4" />
                </linearGradient>
                <linearGradient id="retFill" x1="0" y1="0" x2="0" y2="1">
                  <stop offset="0%" stopColor="#8B5CF6" stopOpacity={0.35} />
                  <stop offset="100%" stopColor="#06B6D4" stopOpacity={0} />
                </linearGradient>
              </defs>
              <CartesianGrid stroke="rgba(255,255,255,0.05)" vertical={false} />
              <XAxis dataKey="name" tick={{ fill: "#64748B", fontSize: 11 }} axisLine={false} tickLine={false} />
              <YAxis domain={[0, 100]} tick={{ fill: "#64748B", fontSize: 11 }} axisLine={false} tickLine={false} />
              <Tooltip
                contentStyle={{ background: "#1A2345", border: "1px solid rgba(139,92,246,0.35)", borderRadius: 12, color: "#F8FAFC", fontSize: 12 }}
                labelStyle={{ color: "#CBD5E1" }} formatter={(v) => [`${v}%`, "Retención"]}
              />
              <Area type="monotone" dataKey="ret" stroke="url(#retLine)" strokeWidth={2.5} fill="url(#retFill)"
                dot={{ r: 4, fill: "#0A1024", stroke: "#06B6D4", strokeWidth: 2 }}
                activeDot={{ r: 6, fill: "#8B5CF6", stroke: "#fff", strokeWidth: 2 }}
                style={{ filter: "drop-shadow(0 0 6px rgba(139,92,246,0.55))" }} />
            </AreaChart>
          </ResponsiveContainer>
        </div>

        <div className="mt-5 grid md:grid-cols-2 gap-3">
          {blocks.map((block) => {
            const tone = scoreTone(block.estimated_retention);
            return (
              <div key={`block-${block.block_name}-${block.timestamp}`} className="rounded-xl border border-white/10 bg-brand-elevated/60 p-4 border-l-2" style={{ borderLeftColor: tone.ring }}>
                <div className="flex items-center justify-between gap-2 mb-2">
                  <div className="min-w-0">
                    <span className="font-bold text-vt-ink">{block.block_name}</span>
                    <span className="text-xs text-brand-muted ml-2">{block.timestamp}</span>
                  </div>
                  <div className="flex items-center gap-2 shrink-0">
                    <span className="text-sm font-semibold text-brand-text2">{TREND[block.trend] || block.trend}</span>
                    <span className={`vt-score text-lg font-extrabold ${tone.text}`}>{block.estimated_retention}%</span>
                  </div>
                </div>
                <p className="text-sm text-brand-text2 mb-1"><strong className="text-vt-ink">Razón:</strong> {block.reason}</p>
                {block.retention_drop && <p className="text-sm text-rose-300 font-semibold mb-1">Caída: {block.retention_drop}%</p>}
                {block.fix && <p className="text-sm text-cyan-200"><strong className="text-cyan-300">Solución:</strong> {block.fix}</p>}
                {block.improvement && block.improvement !== "Óptimo" && <p className="text-sm text-cyan-200"><strong className="text-cyan-300">Mejora:</strong> {block.improvement}</p>}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
